// apiConfig.js
// export const BASE_URL = "http://localhost:3070";
export const BASE_URL = "https://vertobackendapp.azurewebsites.net";
// export const BASE_URL = "https://vertobackendappdev.azurewebsites.net";